import { AfterViewInit, Component, HostListener, Renderer2 } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  currentUrl: string = '';

  constructor(
    public _router: Router,
    location: PlatformLocation,
    private renderer: Renderer2
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        // Force sidebar open after each navigation
        this.forceSidebarOpen();
        // Repeat after short delay to override late scripts
        setTimeout(() => this.forceSidebarOpen(), 300);
      }
      window.scrollTo(0, 0);
    });
  }

  // your previous ngAfterViewInit and onResize with these
  ngAfterViewInit(): void {
    this.forceSidebarOpen();
    setTimeout(() => this.forceSidebarOpen(), 500);
    setTimeout(() => this.forceSidebarOpen(), 1500);
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(() => this.forceSidebarOpen(), 300);
  }

  /**
   * Keeps sidebar visible across view changes, resizing, and template overrides.
   */
  private forceSidebarOpen() {
    try {
      // Remove controlling class from body
      this.renderer.removeClass(document.body, 'ls-closed');

      // Sidebar element
      const sidebar = document.querySelector('.sidebar, #leftsidebar') as HTMLElement;
      if (sidebar) {
        sidebar.style.display = 'flex';
        sidebar.style.transform = 'none';
        sidebar.style.visibility = 'visible';
        sidebar.style.opacity = '1';
      }

      // Sidebar menu text
      const menuTexts = document.querySelectorAll('.sidebar .menu .list a .hide-menu');
      menuTexts.forEach(el => {
        const element = el as HTMLElement;
        element.style.display = 'inline-block';
        element.style.visibility = 'visible';
        element.style.opacity = '1';
      });

      console.log('Sidebar forcefully made visible');
    } catch (e) {
      console.error('Error forcing sidebar open:', e);
    }
  }
}
